// extracted by mini-css-extract-plugin
module.exports = {"safearea":"Safearea_safearea_nUg24"};